<template>
  <div
    v-if="isAppReady"
    id="app"
    ref="app"
    class="app"
    :class="{
      'sociolla-universe-v1': showHeader && showFooter,
      'head-prod-detail': showingModalTellFriends,
    }"
  >
    <meta-tag></meta-tag>
    <Navbar v-if="showHeader"></Navbar>
    <!-- <ModalAnnouncement v-if="showLoyaltyAnnouncement"></ModalAnnouncement> -->
    <router-view />
    <ShareTemplate type="wa" :review-data="reviewData" />
    <ShareTemplate type="fb" :review-data="reviewData" />

    <Footer v-if="showFooter"></Footer>
    <ModalTellFriends v-if="showModalTellFriends && showingModalTellFriends" />
    <ModalSearchProduct v-if="showModalSearchProduct" />
    <ModalUserPhotos v-if="isOpenGlobalModalUserPhotos" key="GlobalModalUserPhotos" />
    <ModalEditReview v-if="showModalEditReview" />
    <ModalPrivacyPolicy v-if="showModalPrivacyPolicy" />
    <ModalTnc v-if="showModalTnc" />
    <ModalConfirmBeautyProfile v-if="showModalConfirmBP" />
    <ModalShareExperience v-if="showModalShareExperience" />

    <div class="page--create-review">
      <ModalConfirmationPhoto v-if="showModalConfirmationPhoto" />
      <ModalUploadPhoto v-if="showModalUploadPhoto" />
      <ModalCropPhoto v-if="showModalCropPhoto" />
      <ModalEditPhoto v-if="showModalEditPhoto" />
      <ModalConfirmationEdit v-if="showModalConfirmationEdit" />
      <ModalReviewError
        v-if="showModalReviewError"
        @close-modal="$store.commit('toggleModalGlobalState', { modalName: 'reviewError' })"
      />
    </div>
    <Login />
  </div>
</template>

<script>
import { initiate as initSession, fetchSession } from 'sociolla-analytics/actions/session';
import Auth from './shared/auth';
const Config = require('~/config/default.env').default;

export default {
  name: 'App',
  components: {
    Navbar: () => import('@/components/global/navbar/navbar-v2'),
    Footer: () => import('@/components/global/footer/footer'),
    ModalSearchProduct: () => import('@/components/review/review-create/snippet/modal-search-product'),
    MetaTag: () => import('@/components/global/MetaTag'),
    ModalUserPhotos: () => import('@/components/global/modal/modal-user-photos'),
    ModalEditReview: () => import('@/components/global/modal/modal-edit-review'),
    ModalConfirmationPhoto: () => import('@/components/global/modal/modal-confirmation-photo'),
    ModalUploadPhoto: () => import('@/components/review/review-create/snippet/modal-upload-photo'),
    ModalCropPhoto: () => import('@/components/review/review-create/snippet/modal-crop-photo'),
    ModalEditPhoto: () => import('@/components/review/review-create/snippet/modal-edit-photo'),
    ModalConfirmationEdit: () => import('@/components/global/modal/modal-confirmation-edit'),
    ModalTellFriends: () => import('@/components/global/modal/modal-tell-friends'),
    ModalReviewError: () => import('@/components/review/review-create/snippet/modal-error'),
    Login: () => import('@/components/global/login/login-v2'),
    ModalConfirmBeautyProfile: () => import('@/components/global/modal/modal-confirm-beauty-profile'),
    ModalPrivacyPolicy: () => import('@/components/global/login/modal-privacy-policy'),
    ModalTnc: () => import('@/components/global/login/modal-tnc'),
    ShareTemplate: () => import('@/components/global/share-template/share-template'),
    ModalShareExperience: () => import('@/components/global/modal/modal-share-experience'),
  },
  data() {
    return {
      isAppReady: false,
      isSentTrackingAnalytic: false,
    };
  },
  computed: {
    isOpenGlobalModalUserPhotos() {
      return this.$store.state.modal.userPhotos.isOpen;
    },
    showModalSearchProduct() {
      return this.$store.state.writeReview.showModal;
    },
    showModalEditReview() {
      return this.$store.state.modal.isModalShow.editReview;
    },
    showModalTellFriends() {
      return this.$store.state.modal.isModalShow.tellFriends;
    },
    showModalConfirmationPhoto() {
      return this.$store.state.modal.isModalShow.confirmationPhoto;
    },
    showModalUploadPhoto() {
      return this.$store.state.writeReview.showModalUploadPhoto;
    },
    showModalCropPhoto() {
      return this.$store.state.writeReview.showModalCropPhoto;
    },
    showModalEditPhoto() {
      return this.$store.state.writeReview.showModalEditPhoto;
    },
    showModalConfirmationEdit() {
      return this.$store.state.modal.isModalShow.confirmationEdit;
    },
    showModalReviewError() {
      return this.$store.state.modal.isModalShow.reviewError;
    },
    showModalPrivacyPolicy() {
      return this.$store.state.modal.isModalShow.privacyPolicy;
    },
    showModalTnc() {
      return this.$store.state.modal.isModalShow.tnc;
    },
    showLoyaltyAnnouncement() {
      // return this.$store.state.auth && this.$store.state.auth.loggedin && this.$store.state.auth.userProfile && document.cookie.indexOf(`LoyaltyAnnouncement-review-${this.$store.state.auth.userProfile.user_name}=1`) < 0
      return false;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    showFooter() {
      // Only show footer for homepage in mobile view
      if (!this.isDesktop) {
        if (this.$route.name == 'Dashboard') {
          return true;
        }
        return false;
      }
      return !['BeautyProfile', 'Recommendation', 'RegisterDetail'].includes(this.$route.name);
    },
    showHeader() {
      return !(this.$route.name === 'Recommendation' && !this.$store.state.screen.isDesktop);
    },
    showingModalTellFriends() {
      const routeName = this.$route.name;
      if (routeName === 'productDetail' || routeName === 'BrandDetail' || 'Dashboard') {
        return true;
      } else {
        return false;
      }
    },
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    reviewData() {
      return this.$store.state.reviewData;
    },
    showModalShareExperience() {
      return this.$store.state.modal.isModalShow.shareExperience;
    },
    showModalConfirmBP() {
      return this.$store.state.modal.isModalShow.confirmBP;
    },
  },
  watch: {
    isAppReady(newVal) {
      if (newVal) {
        this.$store.dispatch('getCategoriesShopByDepartments');
        this.getAllThirdParty();
      }
    },
  },
  created() {
    initSession();
    const context = this;
    context.isAppReady = true;
    Auth.me(context).catch((err) => {
      context.isAppReady = true;
      console.log(err);
    });

    const stateCheck = setInterval(() => {
      if (document.readyState === 'complete') {
        clearInterval(stateCheck);
        window.googletag = window.googletag || { cmd: [] };
        document.dispatchEvent(new CustomEvent('scriptReady'));
      }
    }, 100);

    this.getWindowSize();
  },
  updated() {
    this.$nextTick(function () {
      if (!this.isSentTrackingAnalytic) {
        this.isSentTrackingAnalytic = true;
        setTimeout(() => {
          this.trackingSystemLoggedIn();
        }, 500);
      }
    });
  },
  methods: {
    debounce(func, limit) {
      let timer;

      return function debounced(...args) {
        clearTimeout(timer);

        timer = setTimeout(() => {
          timer = null;
          func.apply(this, args);
        }, limit);
      };
    },
    getWindowSize() {
      const w = window;
      const d = document;
      const e = d.documentElement;
      const g = d.getElementsByTagName('body')[0];
      const windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
      const windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

      this.$store.dispatch('setScreenSize', {
        width: windowWidth,
        height: windowHeight,
      });

      this.$SO(window).on('resize', this.debounce(this.onWindowResize, 150));
    },
    onWindowResize() {
      const w = window;
      const d = document;
      const e = d.documentElement;
      const g = d.getElementsByTagName('body')[0];
      const windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
      const windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

      this.$store.dispatch('setScreenSize', {
        width: windowWidth,
        height: windowHeight,
      });
    },
    getAllThirdParty() {
      // eslint-disable-next-line no-var
      var gtm_script_check = document.getElementById('gtm-script');
      if (!gtm_script_check) {
        // eslint-disable-next-line no-var
        var gtm_script = document.createElement('script');
        gtm_script.id = 'gtm-script';
        gtm_script.defer = true;
        gtm_script.type = 'text/javascript';
        gtm_script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-PN6HLN');`;
        document.body.appendChild(gtm_script);
      }
    },
    async trackingSystemLoggedIn() {
      const uniqueId = fetchSession();
      const payload = {
        verb: 'tap',
        user_id: this.$store.state.userProfile ? this.$store.state.userProfile.id : '',
        is_guest: !this.isLogin,
        device_id: uniqueId,
        accessed_at: new Date(),
        acquisition_source: this.$store.state.screen.isDesktop ? 'review-web-desktop' : 'review-web-mobile',
      };
      try {
        await axios.post(`${Config.MS_ANALYTICS_API_URL}/user/me/actions`, payload);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
